import React from 'react';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock';

export const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center pt-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-right space-y-6 order-2 md:order-1">
            <div className="inline-block">
              <span className="bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-medium">
                الشريك الموثوق في قطع غيار السيارات
              </span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              {companyInfo.name}
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {companyInfo.tagline}
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              {companyInfo.description}
            </p>

            <div className="space-y-3">
              {[
                'قطع غيار أصلية ومعتمدة',
                'أسعار تنافسية',
                'توصيل سريع في جميع أنحاء ليبيا'
              ].map((feature, index) => (
                <div key={index} className="flex items-center gap-3 justify-end">
                  <span className="text-gray-700">{feature}</span>
                  <CheckCircle2 className="h-5 w-5 text-green-600" />
                </div>
              ))}
            </div>

            <div className="flex gap-4 justify-end pt-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-blue-900 hover:bg-blue-800 text-white px-8 py-6 text-lg transition-all hover:scale-105"
              >
                تواصل معنا
                <ArrowLeft className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </div>

          {/* Image/Visual Element */}
          <div className="order-1 md:order-2">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-200 rounded-3xl transform rotate-6 opacity-20"></div>
              <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 rounded-3xl p-12 text-white shadow-2xl">
                <div className="space-y-6">
                  <div className="text-center">
                    <div className="text-7xl font-bold mb-4">15+</div>
                    <p className="text-xl text-blue-100">سنة من الخبرة</p>
                  </div>
                  <div className="h-px bg-blue-500"></div>
                  <div className="text-center">
                    <div className="text-7xl font-bold mb-4">1000+</div>
                    <p className="text-xl text-blue-100">عميل راضٍ</p>
                  </div>
                  <div className="h-px bg-blue-500"></div>
                  <div className="text-center">
                    <div className="text-7xl font-bold mb-4">100%</div>
                    <p className="text-xl text-blue-100">ضمان الجودة</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};